import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { paddingLeft } from '@/utils/directions';
import { changeMobileSidebarVisibility, changeSidebarVisibility } from '@/stores/actions/sidebarActions';
import { changeThemeToDark, changeThemeToLight } from '@/stores/actions/themeActions';
import Topbar from './topbar/Topbar';
import Sidebar from './components/sidebar/Sidebar';
import { RootState } from '@/stores';
// import WelcomeNotification from './components/WelcomeNotification';

const Layout = () => {
    const dispatch = useDispatch();
    const { sidebar } = useSelector((state: RootState) => ({ sidebar: state.sidebar }));

    // const [isNotificationShown, setIsNotificationShown] = useState(false);

    // useEffect(() => {
    // if (!isNotificationShown) {
    //     WelcomeNotification(theme, rtl, setIsNotificationShown, isNotificationShown);
    // }
    // }, [theme, rtl, isNotificationShown]);

    const sidebarVisibility = () => {
        dispatch(changeSidebarVisibility());
    };

    const mobileSidebarVisibility = () => {
        dispatch(changeMobileSidebarVisibility());
    };

    const changeToDark = () => {
        dispatch(changeThemeToDark());
    };

    const changeToLight = () => {
        dispatch(changeThemeToLight());
    };

    return (
        <LayoutContainer collapse={sidebar.collapse}>
            <Topbar changeMobileSidebarVisibility={mobileSidebarVisibility} changeSidebarVisibility={sidebarVisibility} />
            <Sidebar
                sidebar={sidebar}
                changeToDark={changeToDark}
                changeToLight={changeToLight}
                changeMobileSidebarVisibility={mobileSidebarVisibility}
            />
        </LayoutContainer>
    );
};

export default Layout;

interface LayoutContainerProps {
    collapse: boolean;
}

const LayoutContainer = styled.div<LayoutContainerProps>`
    & + div {
        ${(props) =>
            props.collapse &&
            `
      ${paddingLeft(props)}: 0;
    `};

        @media screen and (min-width: 576px) {
            ${(props) =>
                props.collapse &&
                `
        ${paddingLeft(props)}: 60px;
      `}
        }
    }
`;
